export class SetEvent {
  static readonly type = '[Event] Set'
  constructor(public event: any) {}
}

export class UpdateEventField {
  static readonly type = '[Event] Update Field'
  constructor(
    public section: 'base' | 'sr-event',
    public field: string,
    public value: any,
  ) {}
}

export class ResetEvent {
  static readonly type = '[Event] Reset'
}
